window.addEventListener("load", () => {
  // Variables
  const icons = document.querySelectorAll(".interactive-map__icon-wrapper");
  const map = document.querySelector(".interactive-map__image-wrapper");
  const contentWrapper = document.querySelector(
    ".interactive-map__content",
  );
  const mapTitlesWrapper = document.querySelector(
    ".interactive-map__item-wrapper",
  );
  let mapTitles = document.querySelectorAll(".interactive-map__item");
  let contentSingle = document.querySelector(".interactive-map__single-item");
  // Event Listeners

  Array.from(icons).forEach((icon) => {
    icon.addEventListener("click", (e) => {
      e.stopPropagation();
      let item = document.querySelector(
        `.interactive-map__item[data-id="${e.target.dataset.id}"]`,
      );

      hideElement(mapTitlesWrapper);
      showElement(contentSingle, "flex");
      updateSingleItemContent(
        item.querySelector(".interactive-map__title").getInnerHTML(),
        item.querySelector(".interactive-map__copy").getInnerHTML(),
      );
    });
  });

  for (title of mapTitles) {
    title.addEventListener("click", (e) => {
      e.stopPropagation();

      hideElement(mapTitlesWrapper);
      showElement(contentSingle, "flex");
      updateSingleItemContent(
        e.target.getInnerHTML(),
        e.target.nextElementSibling.getInnerHTML(),
      );
    });
  }

  document.addEventListener("click", () => {
    showElement(mapTitlesWrapper, "flex");
    hideElement(contentSingle);
  });
  // Functions
  const init = () => {
    Array.from(icons).forEach((icon) => {
      setIconPosition(icon, icon.dataset.top, icon?.dataset.left);
    });
  };

  const setIconPosition = (icon, top, left) => {
    if (top === undefined || left === undefined) return;
    try {
      icon.style.top = `${top}%`;
      icon.style.left = `${left}%`;
    } catch (error) {
      console.log(error);
    }
  };

  const hideElement = (el) => {
    //el.style.display = "none";
  };
  const showElement = (el, displayType) => {
    //el.style.display = displayType;
  };

  const updateSingleItemContent = (title, content) => {
    let titleElement = document.querySelector(".interactive-map__single-title");
    let contentElement = document.querySelector(
      ".interactive-map__single-copy",
    );

    titleElement.innerText = title;
    contentElement.innerHTML = content;
  };
  init();
});
